import React from "react";
import { avatarSrc } from "../lib/chat";

// Small circular avatar: shows uploaded image (object storage URL or legacy base64) or initials fallback
export default function Avatar({ src: raw, name = "", size = 32, tint = "#4F6BFF" }) {
  const src = avatarSrc(raw);
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  return (
    <span
      className="inline-flex items-center justify-center rounded-full overflow-hidden flex-shrink-0 border border-slate-200 bg-brand-50"
      style={{ width: size, height: size }}
      title={name}
    >
      {src ? (
        <img src={src} alt={name} className="h-full w-full object-cover" />
      ) : (
        <span className="font-bold" style={{ color: tint, fontSize: size * 0.42 }}>{initial}</span>
      )}
    </span>
  );
}
